const INITIAL_STATE = {
  loading: true,
  list: [],
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'USER_INDIVIDUAL_ANSWERS_LOAD':
      return { ...state, loading: action.payload };
    case 'USER_INDIVIDUAL_ANSWERS_FETCHED':
      return { ...state, list: action.payload, loading: false };
    default:
      return state;
  }
};
